module.exports = __webpack_public_path__ + "img/exclamation-triangle.f651c243.svg";